import { setAlert } from './alertSlice';
import { createSlice } from '@reduxjs/toolkit';
import * as REQUESTS from '../api/streamRequests';
import { loadUser } from './authSlice';
import { STREAM_INSTRUCTION } from 'constants/routes';
import { DASHBOARD } from 'constants/routes';

const initialState = {
  createdStream: null,
  endedStream: null,
  isLive: false,
  loading: false,
};

const streamSlice = createSlice({
  name: 'stream',
  initialState,
  reducers: {
    setCreatedStream(state, action) {
      state.createdStream = action.payload;
      state.loading = false;
    },
    setIsLive(state, action) {
      state.isLive = action.payload;
      state.loading = false;
    },
    setEndedStream(state, action) {
      state.endedStream = action.payload;
      state.loading = false;
    },
    setLoading(state) {
      state.loading = !state.loading;
    },
  },
});

export const {
  setCreatedStream,
  setEndedStream,
  setLoading,
  setIsLive,
} = streamSlice.actions;

export default streamSlice.reducer;

// create Stream
export const createStream = (formData, history) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const resData = await REQUESTS.createStream(formData);
    const { success, stream } = resData;

    if (success) {
      dispatch(loadUser());
      dispatch(setCreatedStream(stream));
      dispatch(
        setAlert(
          'Stream Created. Now read the instructions below to go live.',
          'success'
        )
      );
      history.push(STREAM_INSTRUCTION);
    }
  } catch (err) {
    dispatch(setLoading());
    dispatch(setAlert(err.response.data.error, 'danger'));
  }
};

// go Live
export const goLive = () => async (dispatch) => {
  try {
    dispatch(setLoading());
    const resData = await REQUESTS.goLive();
    const { success } = resData;

    if (success) {
      dispatch(loadUser());
      dispatch(setIsLive(true));
      dispatch(setAlert('You are now live.', 'success'));
    }
  } catch (err) {
    dispatch(setLoading());
    dispatch(setAlert(err.response.data.error, 'danger'));
  }
};

// end Stream
export const endStream = (history) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const resData = await REQUESTS.endStream();
    const { success, stream } = resData;

    if (success) {
      dispatch(loadUser());
      dispatch(setEndedStream(stream));
      dispatch(setIsLive(false));
      dispatch(setAlert('Stream has been ended.', 'success'));
      history.push('/dashboard');
    }
  } catch (err) {
    dispatch(setLoading());
    dispatch(setAlert(err.response.data.error, 'danger'));
  }
};
